import React from 'react';
import NameAndValue from './NameAndValue';
import styles from './NewAttribute.module.sass';

const NewAttribute = () => {
  return (
    <div className={styles.row}>
        <div className={styles.col}>
          <NameAndValue className={styles.card} />
          </div></div>
  )
}

export default NewAttribute